package com.milta.core.localization

import androidx.compose.runtime.staticCompositionLocalOf
import cafe.adriel.lyricist.LanguageTag
import com.milta.core.localization.translations.en.EnStrings
import com.milta.core.localization.translations.fr.FrStrings
import com.milta.core.localization.translations.nl.NlStrings
import com.milta.core.localization.translations.ro.RoStrings
import com.milta.core.localization.translations.bg.BgStrings
import com.milta.core.localization.translations.sq.SqStrings
import com.milta.core.localization.translations.pl.PlStrings
import com.milta.core.localization.translations.it.ItStrings
import com.milta.core.localization.translations.es.EsStrings
import com.milta.core.localization.translations.de.DeStrings

data class AppStrings(
    val common: CommonStrings,
    val auth: AuthStrings,
    val errors: ErrorStrings,
    val home: HomeStrings,
    val profile: ProfileStrings,
    val subscription: SubscriptionStrings,
    val route: RouteStrings,
    val team: TeamStrings,
    val subscriptionExpired: SubscriptionExpiredStrings,
    val imports: ImportsStrings,
    val ocrScan: OcrScanStrings,
    val spreadsheetImport: SpreadsheetImportStrings,
    val webImportRoute: WebImportRouteStrings,
    /** MIL-99 — "Adresse de chargement", mobile CreateRouteScreen + web WebVerifyAssignRouteScreen. */
    val loadingAddress: LoadingAddressStrings,
    /** MIL-99 — unlocated deliveries: creator warning/correction, driver badge (mobile + web). */
    val unlocatedDelivery: UnlocatedDeliveryStrings,
    /** Retour 26/10 (demande 2) — route creation in steps + house-number check (mobile + web). */
    val routeCreation: RouteCreationStrings,
    val settings: SettingsStrings,
    val webDashboard: WebDashboardStrings,
    val webHistorique: WebHistoriqueStrings,
    val adminUsers: AdminUsersStrings,
    val adminPrompts: AdminPromptsStrings,
    val adminOcrAnalysis: AdminOcrAnalysisStrings,
    /** MIL-97 — RoutaR optimization counter per account (mobile, web dashboard and Admin). */
    val optimizationQuota: OptimizationQuotaStrings,
    /** MIL-98 — AI credit per account (mobile, web dashboard and Admin). */
    val aiCredit: AiCreditStrings,
    /** Public web pages reachable without signing in (`/delete-account`, Google Play requirement). */
    val publicPages: PublicPagesStrings,
)

val Strings: Map<LanguageTag, AppStrings> = mapOf(
    "fr" to FrStrings,
    "nl" to NlStrings,
    "en" to EnStrings,
    "ro" to RoStrings,
    "bg" to BgStrings,
    "sq" to SqStrings,
    "pl" to PlStrings,
    "it" to ItStrings,
    "es" to EsStrings,
    // MIL-53 — Dashboard Web "Paramètres" language picker only (10 languages); Driver mobile
    // language selection (ProfileScreen) intentionally still offers only the original 9 — German
    // is not a supported Chauffeur-side preference by this ticket's explicit scope.
    "de" to DeStrings,
)

val supportedLanguages: Set<LanguageTag> = Strings.keys.toSet()

fun resolveLanguageTag(systemTag: String): LanguageTag =
    if (systemTag in supportedLanguages) systemTag else "en"

val LocalStrings = staticCompositionLocalOf { EnStrings }
